module.exports = __webpack_public_path__ + "static/media/Mel Limson Headshot.93ecb322.jpeg";